import type React from 'react';

interface CoinStack2IconProps extends React.SVGProps<SVGSVGElement> {
  size?: number;
}

export function CoinStack2Icon({ size = 24, ...props }: CoinStack2IconProps) {
  return (
    <svg
      width={size}
      height={size}
      viewBox="0 0 16 16"
      fill="none"
      xmlns="http://www.w3.org/2000/svg"
      {...props}
    >
      <g id="Coin stack 4">
        <path
          id="Vector (Stroke)"
          fillRule="evenodd"
          clipRule="evenodd"
          d="M4.33452 2.75267C3.39237 3.22375 3 3.78202 3 4.25C3 4.71798 3.39237 5.27625 4.33452 5.74733C5.24676 6.20345 6.54201 6.5 8 6.5C9.45799 6.5 10.7532 6.20345 11.6655 5.74733C12.6076 5.27625 13 4.71798 13 4.25C13 3.78202 12.6076 3.22375 11.6655 2.75267C10.7532 2.29655 9.45799 2 8 2C6.54201 2 5.24676 2.29655 4.33452 2.75267ZM13 6.07862C12.736 6.29272 12.4342 6.48099 12.1127 6.64176C11.0343 7.18094 9.57957 7.5 8 7.5C6.42043 7.5 4.96567 7.18094 3.88731 6.64176C3.56577 6.48099 3.26396 6.29272 3 6.07862V6.75C3 7.21798 3.39237 7.77625 4.33452 8.24733C5.24676 8.70345 6.54201 9 8 9C9.45799 9 10.7532 8.70345 11.6655 8.24733C12.6076 7.77625 13 7.21798 13 6.75V6.07862ZM13 8.57862C12.736 8.79272 12.4342 8.98099 12.1127 9.14176C11.0343 9.68094 9.57957 10 8 10C6.42043 10 4.96567 9.68094 3.88731 9.14176C3.56577 8.98099 3.26396 8.79272 3 8.57862V9.25C3 9.71798 3.39237 10.2763 4.33452 10.7473C5.24676 11.2035 6.54201 11.5 8 11.5C9.45799 11.5 10.7532 11.2035 11.6655 10.7473C12.6076 10.2763 13 9.71798 13 9.25V8.57862ZM13 11.0786C12.736 11.2927 12.4342 11.481 12.1127 11.6418C11.0343 12.1809 9.57957 12.5 8 12.5C6.42043 12.5 4.96567 12.1809 3.88731 11.6418C3.56577 11.481 3.26396 11.2927 3 11.0786V11.75C3 12.218 3.39237 12.7763 4.33452 13.2473C5.24676 13.7035 6.54201 14 8 14C9.45799 14 10.7532 13.7035 11.6655 13.2473C12.6076 12.7763 13 12.218 13 11.75V11.0786ZM2 4.25C2 3.19919 2.83885 2.38247 3.88731 1.85824C4.96567 1.31906 6.42043 1 8 1C9.57957 1 11.0343 1.31906 12.1127 1.85824C13.1612 2.38247 14 3.19919 14 4.25V11.75C14 12.8008 13.1612 13.6175 12.1127 14.1418C11.0343 14.6809 9.57957 15 8 15C6.42043 15 4.96567 14.6809 3.88731 14.1418C2.83885 13.6175 2 12.8008 2 11.75V4.25Z"
          fill="currentColor"
        />
      </g>
    </svg>
  );
}
